export default "__VITE_ASSET__DNVaKZZb__"